import React, { useContext, useState } from "react";
import { putApi } from "../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import Select from "../../common/inputs/Select";
import { Form, Formik } from "formik";
import { context } from "../../../context/context";
const { forwardRef, useRef, useImperativeHandle } = React;

const TicketStatusModal = forwardRef(({ reGetData, data }, ref) => {
  const [showModal, setShowModal] = useState(false);

  const { utils } = useContext(context);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
  }));

  const formHandler = async (values) => {
    const path = `admin/tickets/${data?._id}/status`;
    const body = values;
    try {
      await putApi({ path, body });
      successMessage("وضعیت پیام با موفقیت تغییر کرد.");
      reGetData();
      setShowModal(false);
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };


  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-30  ${
          !showModal && "hidden"
        }`}
        onClick={() => setShowModal(false)}
      ></div>
      <div
        className={`w-[320px] sm:w-[500px] py-4 max-h-[360px] overflow-y-scroll mt-4 flex items-center justify-center bg-white dark:bg-neutral-500  rounded-lg shadow z-40 rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-160px] sm:mr-[-250px] opacity-0 invisible ${
          showModal && "!mt-24 !opacity-100 !visible"
        }`}
      >
        <div>
          <button
            onClick={() => setShowModal(false)}
            type="button"
            className="absolute top-3 end-2.5 text-gray-400 dark:text-gray-200 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            data-modal-hide="popup-modal"
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">بستن مدال</span>
          </button>
          <div className="p-4 md:p-5 text-center">
            <svg
              className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-white">
              تغییر وضعیت پیام کاربر {data?.user?.name}
            </h3>
            <Formik
              enableReinitialize
              initialValues={{
                status: data?.status || "close",
              }}
              onSubmit={formHandler}
            >
              {() => (
                <Form>
                  <div className="flex flex-col gap-4">
                    <Select
                      name="status"
                      placeholder="وضعیت پیام"
                      label="وضعیت پیام"
                    >
                      {utils?.TIECKET_STATUS_VALUES?.length
                        ? utils?.TIECKET_STATUS_VALUES.map((item) => {
                            return (
                              <option value={item?.value}>{item?.name}</option>
                            );
                          })
                        : null}
                    </Select>
                    <div className="flex items-center justify-center gap-2">
                      <button
                        onClick={() => setShowModal(false)}
                        type="button"
                        className="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                      >
                        بازگشت
                      </button>
                      <button
                        type="submit"
                        className="text-white bg-green-600 dark:bg-green-500 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm inline-flex items-center px-10 py-2.5 text-center"
                      >
                        تغییر
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
});
export default TicketStatusModal;
